"use client";

import { EmailFormValues } from "@/lib/auth-flow";
import { useFormContext } from "react-hook-form";
import { AuthField, AuthInput } from "./auth-ui";

/** Must render inside a FormProvider whose values extend EmailFormValues. */
export function EmailField({ serverErrors = {} }: { serverErrors?: Record<string, string[]> }) {
  const {
    register,
    formState: { errors },
  } = useFormContext<EmailFormValues>();
  const error = errors.email?.message ?? serverErrors.email;
  return (
    <AuthField label="Email" htmlFor="email" error={error}>
      <AuthInput
        id="email"
        type="email"
        placeholder="name@example.com"
        autoCapitalize="none"
        autoComplete="email"
        autoCorrect="off"
        invalid={!!error}
        {...register("email", { required: "Email wajib diisi" })}
      />
    </AuthField>
  );
}
